const $REGISTRY = {};

/**
 * Javascript class factory instance.
 * Allows to register unique class constructors and to create instances of those class.
 * @namespace   e.js
 * @class       e.js.Factory
 */
class EJSFactory
{
    /**
     * Registers a class constructor for an unique name.
     * @param   {String}        name    Class constructor unique identifier
     * @param   {Function|null} fn      Class constructor method
     */
    static register(name = '', fn = null)
    {
        if (typeof fn !== 'function')
        {
            throw new Error('[EJSFactory] Expecting a function to register constructor');
        }

        $REGISTRY[name] = fn;
    }

    /**
     * Creates a unique instance of a pre-registered class
     * @param   {String}    name    Class unique identifier
     * @param   {*}         values  Class initial properties and values
     * @return  {Object|undefined}  Class instance
     */
    static create(name = '', values)
    {
        let _Clazz = $REGISTRY[name];
        if (typeof _Clazz === 'function')
        {
            _Clazz = new _Clazz(values);
        }

        return _Clazz;
    }

    /**
     * Returns whether class unique identifier exists or not
     * @param   {String}    name    Class unique identifier
     * @return  {Boolean}   `true` if class is pre-registered, `false` in other case
     */
    static has(name = '')
    {
        return !!$REGISTRY[name];
    }

    /**
     * Returns the pre-registered class by its unique identifier name
     * @param   {String}    name        Class unique identifier name
     * @return  {Function|undefined}    Class constructor or `undefined` in other case
     */
    static get(name = '')
    {
        return $REGISTRY[name];
    }

    /**
     * Returns if an instance of a value matches pre-registered class
     * @param   {String}    name        Class unique identifier
     * @param   {*}         instance    Value to compare
     * @return  {Boolean}   `true` if instance matches class constructor, `false` in other case
     */
    static is(name = '', instance)
    {
        const fn = EJSFactory.get(name);

        return typeof fn === 'function' ? instance instanceof fn : false;
    }

    _delete(key)
    {
        if (Array.isArray(key))
        {
            key.forEach(this._delete.bind(this));
        }
        else if (typeof key === 'string' && key in $REGISTRY)
        {
            delete $REGISTRY[key];
        }
    }
}

EJSFactory.register('EJSFactory', EJSFactory);
module.exports = EJSFactory;
